import { CreateUserDTO } from "../types/user.types";
import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class UsersAPI {
  private static readonly API_URL = "/users";

  static async getAllUsers(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(UsersAPI.API_URL, true),
      "Error al obtener los usuarios"
    );
  }

  static async createUser(user: CreateUserDTO): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(UsersAPI.API_URL, user, true),
      "Error al crear el usuario"
    );
  }

  static async getUserProgress(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${UsersAPI.API_URL}/progress`, true),
      "Error al obtener el progreso de usuario"
    );
  }

  static async getUserHDTickets(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${UsersAPI.API_URL}/help_desk_tickets`, true),
      "Error al obtener los tickets de usuario"
    );
  }

  static async resetUserPassword(userId: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.post(
          `${UsersAPI.API_URL}/${userId}/reset-password`,
          undefined,
          true
        ),
      "Error al resetear la contraseña del usuario"
    );
  }

  static async resetPassword(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.post(`${UsersAPI.API_URL}/reset-password`, undefined, true),
      "Error al resetear la contraseña"
    );
  }
}
